var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie",style:([_vm.getStyle])},[_c('div',{staticClass:"pie-segment",class:{overload: _vm.isOverloading}})])}
var staticRenderFns = []

export { render, staticRenderFns }